import { render, staticRenderFns } from "./CommentAction.vue?vue&type=template&id=d8e1775c&scoped=true&"
import script from "./CommentAction.vue?vue&type=script&lang=ts&"
export * from "./CommentAction.vue?vue&type=script&lang=ts&"
import style0 from "./CommentAction.vue?vue&type=style&index=0&id=d8e1775c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e1775c",
  null
  
)

export default component.exports